<script>
    import { db } from "../../firebase/firestore";
    import { doc, onSnapshot, updateDoc, Timestamp } from "firebase/firestore";
    import Timeframe from "../../components/dateRangePicker/Timeframe.svelte";
    import TimestampInput from "../../components/timestamps/TimestampInput.svelte";
    import EditRewardSystem from "../../components/card/EditRewardSystem.svelte";
    import ViewRewardSystem from "../../components/card/ViewRewardSystem.svelte";
    import CardPreview from "../../components/cards/CardPreview.svelte";
    import EditableSection from "../../components/EditableSection.svelte";
    import Section from "../../components/Section.svelte";
    import DeleteButton from "../../components/card/DeleteButton.svelte";
    import { navigate } from "svelte-routing";
    import { removeCard } from "../../firebase/cards";
    import { offsetDate } from "../../utils/utils";
    import DatePicker from "../../components/datePicker/DatePicker.svelte";
    import Warning from "../../components/ui/Warning.svelte";
    import Milestones from "../../components/card/milestones/Milestones.svelte";

    export let id;
    export let blocked;

    let card;
    let startDate;
    let endDate;
    let redeemableDate;
    const cardRef = doc(db, "cardSettings", id);
    
    const unsubcribe = onSnapshot(cardRef, (doc) => {
        card = doc.data();
        startDate = card.start?card.start.toDate():undefined;
        endDate = card.end?offsetDate(card.end.toDate(), -1):undefined;
        redeemableDate = card.redeemableUntil?offsetDate(card.redeemableUntil.toDate(), -1):undefined;
    });

    function getCardSettingState(cardData) {
        const now = Timestamp.now();
        if (!cardData.name || !cardData.stampCount || cardData.stampCount < 1 || !cardData.businesses || cardData.businesses.length != 1 || !cardData.milestones || cardData.milestones.length < 1 || cardData.milestones[0].rewards.length < 1 || !cardData.milestones[0].type || !(cardData.milestones[0].type == "choice" || cardData.milestones[0].type == "all" || cardData.milestones[0].type == "lottery") || !cardData.start || !cardData.end || !cardData.redeemableUntil) {
            return "incomplete"
        } else if (cardData.end <= now) {
            return "archived"
        } else if (cardData.start > now) {
            return "scheduled"
        } else {
            return "active"
        }
    }

    function saveChanges() {
        console.log("saving: +1");
        card.start = Timestamp.fromDate(startDate);
        card.end = Timestamp.fromDate(offsetDate(endDate, 1));
        card.redeemableUntil = Timestamp.fromDate(offsetDate(redeemableDate, 1));
        card.state = getCardSettingState(card);
        console.log(card);
        try {
            updateDoc(cardRef, card);
            card.end = Timestamp.fromDate(offsetDate(endDate, -1));
            card.redeemableUntil = Timestamp.fromDate(offsetDate(redeemableDate, -1));
            console.log("Success");
        } catch (error) {
            alert ("Beim Speichern ist ein Fehler aufgetreten, bitte versuche es gleich erneut.")
        }
    }

    function saveMilestones() {
        console.log("Saving Milestones");
        console.log(card.milestones);
        card.state = getCardSettingState(card);
        try {
            updateDoc(cardRef, {state: card.state, milestones: card.milestones});
            console.log("Success");
        } catch (error) {
            alert ("Beim Speichern ist ein Fehler aufgetreten, bitte versuche es gleich erneut.")
        }
    }

    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
</script>


{#if card}
    <div class="{card.state}">
        <div class="heading">
            <div class="l1">
                <h1>Stempelkarte: {card.name}</h1>
                <span class="state">{card.state=="active"?"Aktiv":card.state=="scheduled"?"Geplant":card.state=="archived"?"Abgelaufen":"Unvollständig"}</span>
            </div>
            <span>erstellt am {card.created.toDate().toLocaleDateString('de-DE', options)}</span><br>
        </div>

        {#if !card?.milestones?.length > 0 || !card?.milestones[0].rewards?.length > 0}
            <Warning>
                Für diese Stempelkarte ist keine Belohnung eingetragen. Bitte ergänze weiter unten noch mindestens eine Belohnung, damit die Stempelkarte aktiviert wird.
            </Warning>
        {/if}
        
        <CardPreview bind:card />
        <EditableSection title={"Infos"} on:save={() => {saveChanges()}} bind:disabled={card.published}>
            <div slot="edit">
                <label>Name<br>
                    <input bind:value={card.name} type="text">
                </label>
                <label>Stempelanzahl<br>
                    <input bind:value={card.stampCount} type="number">
                </label>
            </div>
            <div slot="view">
                <p>Name: {card.name??"unbenannt"}</p>
                <p>Stempelanzahl: {card.stampCount}</p>
            </div>
        </EditableSection>
        <hr>
        <Section title="Zeitraum">
            <Timeframe bind:blocked bind:start={startDate} bind:id bind:end={endDate} minimumDuration=7 on:confirm={saveChanges}/>
            <DatePicker bind:date={redeemableDate} min={endDate} on:confirm={saveChanges}/>
        </Section>
        <!-- <hr> -->
        <!-- <EditableSection title={"Belohnung"} on:save={() => {saveChanges()}} bind:disabled={card.published}>
            <div slot="edit">
                <EditRewardSystem bind:rewardSystem={card.rewardSystem}/>
            </div>
            <div slot="view">
                <ViewRewardSystem bind:rewardSystem={card.rewardSystem}/>
            </div>
        </EditableSection> -->
        <hr>
        <h2>Belohnungen</h2>
        <Milestones max_stamp_count={card.stampCount} bind:milestones={card.milestones} on:save={() => {saveMilestones()}} bind:disabled={card.published}/>

        <!-- <hr>
        <DeleteButton name={card.name} on:confirm={() => {removeCard(id); navigate("/stempelkarten")}}/> -->
    </div>
{/if}


<style>
    .heading {
        margin-top: 1.34rem;
        margin-bottom: 1.34rem;
    }
    
    .heading .l1{
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    h1 {
        margin: 0;
    }

    .state {
        font-size: 0.8rem;
        padding: 0.2rem 0.4rem;
        border-radius: 0.5rem;
        display: inline-block;
        background-color: rgb(255, 228, 140);
        color: saddlebrown;
    }
    
    .draft .state{        
        background-color: rgb(255, 228, 140);
        color: saddlebrown;
    }

    .active .state{        
        background-color: rgb(180, 230, 170);
        color: rgb(0, 60, 3);
    }

    .archived .state {        
        background-color: rgb(202, 202, 202);
        color: rgb(30, 30, 30);
    }
</style>